/**
 * Portal AI Chat API client (internal testing feature).
 *
 * Restricted to portal_system_admin and portal_developer on the backend.
 */

const API_BASE_URL = 'https://jrgfnay5w2.execute-api.ap-southeast-2.amazonaws.com/v1';

const getAuthToken = () => {
  const oidcStorage = sessionStorage.getItem(
    'oidc.user:https://cognito-idp.ap-southeast-2.amazonaws.com/ap-southeast-2_3n9j6gDzL:2c6na652k2lkcsaa1ol8m5chp4'
  );
  if (oidcStorage) {
    try {
      const oidcData = JSON.parse(oidcStorage);
      return oidcData.id_token || oidcData.access_token;
    } catch (e) {
      console.error('Error parsing OIDC storage:', e);
    }
  }
  return null;
};

const aiChatRequest = async (operation, data = {}) => {
  const token = getAuthToken();
  if (!token) {
    throw new Error('Not authenticated. Please log in again.');
  }

  const response = await fetch(`${API_BASE_URL}/ai-chat`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({ operation, data })
  });

  const result = await response.json();
  if (!response.ok) {
    throw new Error(result.error || `Request failed with status ${response.status}`);
  }
  return result;
};

export const getCampusAiStats = async (campusId) => {
  return aiChatRequest('getStats', { campusId });
};

export const listConversations = async () => {
  const res = await aiChatRequest('listConversations', {});
  return res.conversations || [];
};

export const getConversation = async (conversationId) => {
  const res = await aiChatRequest('getConversation', { conversationId });
  return res.conversation;
};

export const deleteConversation = async (conversationId) => {
  return aiChatRequest('deleteConversation', { conversationId });
};

/**
 * Send a chat message. If conversationId is omitted, a new conversation is created
 * using the provided campusId + model (the backend snapshots campus context).
 * If conversationId is provided, the message is appended to that conversation and
 * the snapshotted context is reused (no re-scan of the campus).
 */
export const askAiChat = async ({ conversationId, campusId, question, model }) => {
  const data = { question, model };
  if (conversationId) data.conversationId = conversationId;
  if (campusId) data.campusId = campusId;
  return aiChatRequest('chat', data);
};

export const AI_CHAT_MODELS = [
  { value: 'gemini-2.5-flash', label: 'Gemini 2.5 Flash (fast, 1M context)' },
  { value: 'gemini-2.5-flash-lite', label: 'Gemini 2.5 Flash-Lite (cheapest)' },
  { value: 'gemini-2.5-pro', label: 'Gemini 2.5 Pro (most capable 2.5)' },
  { value: 'gemini-3-flash-preview', label: 'Gemini 3 Flash Preview' },
  { value: 'gemini-3.1-flash-lite-preview', label: 'Gemini 3.1 Flash-Lite Preview' },
  { value: 'gemini-3.1-pro-preview', label: 'Gemini 3.1 Pro Preview (paid tier only)' }
];

const aiChatApi = {
  getCampusAiStats,
  listConversations,
  getConversation,
  deleteConversation,
  askAiChat,
  AI_CHAT_MODELS
};
export default aiChatApi;
